module.exports = __webpack_public_path__ + "img/truck.0e215000.svg";